
import saMessages from '../locales/ja_JA';

const jaLang = {
    messages: {
        ...saMessages
    },
    locale: 'ja-ja',
   
};

export default jaLang;
